import styles from "./ViewHotspotImage.module.css";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { currentHotspotSelector } from "../../../hooks/store/getters";
import Col from "react-bootstrap/Col";

const ViewHotspotImage = () => {
    
    const currentHotspot = useAppStore(currentHotspotSelector);

    const { image, name } = currentHotspot;
    
    if (!image.url) return null;
    
    return (
        <Col md={6}>
            <div className={styles.hotspotImage}>
                {
                    (image.url || image.file) && (
                        <img src={image.url || image.file} alt={name} />
                    )
                }
            </div>
        </Col>
    );
};

export default ViewHotspotImage;